if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector(".quantity__input");
        this.currentVariant = this.querySelector(".product-variant-id");
        this.variantSelects = this.querySelector("variant-radios");
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            const sectionId = this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section;
            if (event.data.sectionId !== sectionId) return;
            this.updateQuantityRules(event.data.sectionId, event.data.html);
            this.setQuantityBoundries();
          }
        );
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity
            ? parseInt(this.input.dataset.cartQuantity)
            : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        // if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        // Always reset to minimum when variant changes
        this.input.value = min;

        // Remove old event listener if it exists
        if (this.quantityChangeHandler) {
          this.input.removeEventListener("change", this.quantityChangeHandler);
        }

        // Create new validation handler that reads current values from input
        this.quantityChangeHandler = (e) => {
          const currentData = {
            cartQuantity: this.input.dataset.cartQuantity
              ? parseInt(this.input.dataset.cartQuantity)
              : 0,
            min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
            max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
            step: this.input.step ? parseInt(this.input.step) : 1,
          };

          let currentMin = currentData.min;
          const currentMax = currentData.max === null ? currentData.max : currentData.max - currentData.cartQuantity;
          if (currentMax !== null) currentMin = Math.min(currentMin, currentMax);

          const value = parseInt(e.target.value) || 0;
          if (value < currentMin) {
            e.target.value = currentMin;
          } else if (currentMax !== null && value > currentMax) {
            e.target.value = currentMax;
          } else {
            // Check if value is compatible with step (min + n*step)
            const remainder = (value - currentMin) % currentData.step;
            if (remainder !== 0) {
              // Find the closest allowed value
              const steps = Math.round((value - currentMin) / currentData.step);
              const correctedValue = currentMin + steps * currentData.step;
              // Make sure it doesn't exceed max
              if (currentMax === null || correctedValue <= currentMax) {
                e.target.value = correctedValue;
              } else {
                e.target.value = currentMax;
              }
            }
          }
        };

        // Add validation on value change
        this.input.addEventListener("change", this.quantityChangeHandler);

        // Dispatch change event to trigger price update after quantity is reset
        this.input.dispatchEvent(new Event("change", { bubbles: true }));

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector(
          ".quantity__rules-cart .loading-overlay"
        ).classList.remove("hidden");
        fetch(
          `${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`
        )
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector(
              ".quantity__rules-cart .loading-overlay"
            ).classList.add("hidden");
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(
          `Quantity-Form-${sectionId}`
        );
        const selectors = [
          ".quantity__input",
          ".quantity__rules",
          ".quantity__label",
        ];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === ".quantity__input") {
            const attributes = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step",
            ];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null)
                current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

document.addEventListener("DOMContentLoaded", () => {
  const interval = setInterval(() => {
    const labelElement = document.querySelector(
      ".ap-options__radio-container .avp-option-title"
    );
    const inputs = document.querySelectorAll(
      ".ap-options__radio-container .avp-productoptioncheckwrapper input"
    );
    if (labelElement) {
      clearInterval(interval);

      inputs.forEach((input) => {
        if (input.checked) {
          labelElement.setAttribute("data-value", input.value);
        }
        input.addEventListener("change", function () {
          labelElement.setAttribute("data-value", this.value);
        });
      });
    }
  }, 500);
});

document.addEventListener("DOMContentLoaded", () => {
  const interval = setInterval(() => {
    const priceAddElement = document.querySelector(
      "#avp-productoption-totalpriceadd"
    );
    if (priceAddElement) {
      clearInterval(interval);

      function updateAdditionalPrice() {
        const additionalPriceElement = document.querySelector(
          ".product .additional-price-value"
        );
        const additionalPriceWrapper = document.querySelector(
          ".product .additional-price"
        );
        if (priceAddElement && additionalPriceElement) {
          additionalPriceElement.textContent = priceAddElement.textContent;
          if (
            additionalPriceWrapper &&
            additionalPriceWrapper.classList.contains("hidden")
          ) {
            additionalPriceWrapper.classList.remove("hidden");
          }
        }
      }

      const observer = new MutationObserver((mutationsList, observer) => {
        for (const mutation of mutationsList) {
          if (mutation.type === "childList" || mutation.type === "subtree") {
            updateAdditionalPrice();
          }
        }
      });

      observer.observe(priceAddElement, {
        childList: true,
        subtree: true,
      });

      updateAdditionalPrice();
    }
  }, 500);
});

document.addEventListener("DOMContentLoaded", function () {
  const initialPriceElement = document.querySelector(
    ".current_price-wrapper .current-price"
  );
  const initialQuantityInput = document.querySelector(
    ".product .product-form-buy-buttons .quantity__input"
  );

  if (!initialPriceElement || !initialQuantityInput) return;

  const currency =
    initialPriceElement.getAttribute("data-current-price-currency") || "PLN";

  const vatRate = 1.23;

  function formatShopifyPrice(price) {
    return new Intl.NumberFormat("pl-PL", {
      style: "currency",
      currency: currency,
    }).format(price / 100);
  }

  // Reads the base price + volume-discount tiers from a given price-data
  // element and returns the net unit price after the applicable discount.
  function calculateDiscountedPrice(quantity, priceElement) {
    if (!priceElement) return 0;

    const basePrice = parseFloat(
      priceElement.getAttribute("data-current-price")
    );
    if (isNaN(basePrice)) return 0;

    let discount = 0;

    for (let i = 1; i <= 5; i++) {
      const tierQuantity = parseInt(
        priceElement.getAttribute(`data-current-price-tier-0${i}-quantity`)
      );
      const tierDiscount = parseInt(
        priceElement.getAttribute(`data-current-price-tier-0${i}-discount`)
      );

      if (
        !isNaN(tierQuantity) &&
        !isNaN(tierDiscount) &&
        quantity >= tierQuantity
      ) {
        discount = tierDiscount;
      }
    }

    if (discount <= 0) return basePrice;

    // Round the per-unit discount UP, i.e. the discounted unit price DOWN to a
    // whole grosz. Same rule as the discount function, so the price shown here
    // matches the cart and the checkout — see DISCOUNTS.md, "Zaokraglanie".
    // basePrice is already an integer number of grosz (Liquid `variant.price`);
    // rounding it guards against anything else ending up in the attribute.
    const unit = Math.round(basePrice);
    return unit - Math.min(Math.ceil((unit * discount) / 100), unit);
  }

  // Updates a single price wrapper. The IDs inside are duplicated once the
  // AVIS Product Options app clones this block (as .apo-variant-price), so we
  // scope every lookup to the wrapper and select by class, never by id.
  function updatePriceWrapper(wrapper, quantity) {
    const priceElement = wrapper.querySelector(".current-price");
    if (!priceElement) return;

    const newPrice = calculateDiscountedPrice(quantity, priceElement);
    // newPrice is a whole number of grosz, so the line total is exactly
    // `unit x quantity` — the invariant Dalpo Handel relies on. Multiplying an
    // unrounded unit price here was why the PDP showed 2,53 zl/szt next to a
    // total of 910,08 zl for 360 pieces.
    const bruttoPrice = Math.round(newPrice * vatRate);
    const totalNetPrice = newPrice * quantity;
    const totalBruttoPrice = Math.round(totalNetPrice * vatRate);

    const priceValueElement = wrapper.querySelector(".current-price-value");
    if (priceValueElement) {
      priceValueElement.textContent = formatShopifyPrice(newPrice);
    }
    priceElement.classList.remove("hidden");

    const bruttoPriceElement = wrapper.querySelector(".brutto-price");
    const bruttoPriceValueElement = wrapper.querySelector(".brutto-price-value");
    if (bruttoPriceElement && bruttoPriceValueElement) {
      bruttoPriceValueElement.textContent = formatShopifyPrice(bruttoPrice);
      bruttoPriceElement.classList.remove("hidden");
    }

    const totalNettoEl = wrapper.querySelector(".total-price-netto");
    const totalNettoValEl = totalNettoEl?.querySelector(".total-price-value");
    const totalBruttoEl = wrapper.querySelector(".total-price-brutto");
    const totalBruttoValEl = totalBruttoEl?.querySelector(".total-price-value");
    if (quantity > 0) {
      if (totalNettoEl && totalNettoValEl) {
        totalNettoValEl.textContent = formatShopifyPrice(totalNetPrice);
        totalNettoEl.classList.remove("hidden");
      }
      if (totalBruttoEl && totalBruttoValEl) {
        totalBruttoValEl.textContent = formatShopifyPrice(totalBruttoPrice);
        totalBruttoEl.classList.remove("hidden");
      }
    } else {
      totalNettoEl?.classList.add("hidden");
      totalBruttoEl?.classList.add("hidden");
    }
  }

  function updatePrice() {
    const quantityInput = document.querySelector(
      ".product .product-form-buy-buttons .quantity__input"
    );
    if (!quantityInput) return;

    const quantity = parseInt(quantityInput.value) || 0;
    // Update every price wrapper, including the copy the AVIS Product Options
    // app clones into its own UI (it hides the original theme block, so only
    // updating the first match left the visible price frozen).
    document
      .querySelectorAll(".current_price-wrapper")
      .forEach((wrapper) => updatePriceWrapper(wrapper, quantity));
  }

  initialQuantityInput.addEventListener("input", updatePrice);
  initialQuantityInput.addEventListener("change", updatePrice);

  // Subscribe to quantityUpdate event to update price when quantity is reset
  subscribe(PUB_SUB_EVENTS.quantityUpdate, () => {
    // Small delay to ensure input value is updated
    setTimeout(updatePrice, 0);
  });

  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const variant = event.data?.variant;
    if (!variant) return;

    document.querySelectorAll(".current_price-wrapper .current-price").forEach((priceElement) => {
      priceElement.setAttribute("data-current-price", variant.price);
    });

    updatePrice();
  });

  updatePrice();
});
